<template>
  <div class="form-group" :class="{ 'has-error': error }">
    <label :for="$attrs.id" :class="{ required }" :style="labelFontSize">
      <strong>{{ label }}</strong>
    </label>
    <slot name="tag"></slot>
    <input
      v-bind="$attrs"
      v-on="listeners"
      :value="value"
      :class="formClass"
      autocomplete="new-password"
      data-testid="base-input-testid"
      :checked="checked"
    />
    <span v-show="error" class="help-block">{{ error }}</span>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      value: {
        type: [String, Number, Boolean],
      },
      label: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        default: '',
      },
      isLargeFont: {
        type: Boolean,
        default: true,
      },
      isFormControl: {
        type: Boolean,
        default: true,
      },
      checked: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: (e) => {
            if (this.$attrs.type === 'checkbox') {
              this.$emit('input', e.target.checked);
            } else {
              this.$emit('input', e.target.value);
            }
          },
        };
      },
      // opinionated font size for label tag
      labelFontSize() {
        const fontSize = this.isLargeFont ? 20 : 16;
        return {
          fontSize: `${fontSize}px`,
        };
      },
      formClass() {
        if (this.isFormControl) {
          return 'form-control';
        }
        return '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  label {
    &.required::after {
      content: '*';
      color: red;
    }
  }
</style>
